import React, { useEffect, useState } from "react";
import { ErrorType } from "../../../types/common-type";
import handleClearError from "../../../core/methods/handleClearError";
import ErrorMessage from "../../../core/common/ErrorMessage";
import Table from "../../../core/common/dataTable/index";
import { cellWidth } from "../../../core/methods/tableCellWidth";
import { dummyData_allBulk } from "../../../core/data/js/dummy-data";
import TabItems from "../../../core/common/TabItems";
import { toast } from "react-toastify";
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import { formatDateDDMMMMYYYY } from "../../../core/methods/formattedDate";
import Loading from "../../../core/common/custom-loading/Loading";
import { ColumnsType } from "antd/es/table";
import {
  safeDateSort,
  safeNumberSort,
  safeStringSort,
} from "../../../core/methods/sorterMethods";
import { OrderFilterProps } from "../manage-order/AssignOrderToCandidate";
import Swal from "sweetalert2";

export const dummyData_valid = dummyData_allBulk.filter(
  (candidate) => candidate.status === "Valid",
);
export const dummyData_invalid = dummyData_allBulk.filter(
  (candidate) => candidate.status === "Invalid",
);
export const dummyData_duplicate = dummyData_allBulk.filter(
  (candidate) => candidate.status === "Duplicate",
);

interface SingleProps {
  orderFilter: OrderFilterProps;
  orderId: string | undefined;
}

const BulkAssign = ({ orderFilter, orderId = "" }: SingleProps) => {
  const [uploadResponse, setUploadResponse] = useState<any>(null);
  // tabs
  const tabs = [
    {
      id: "allApplicants",
      label: "Valid Applicants",
      data: uploadResponse?.success,
      count: uploadResponse?.success_count || 0,
    },
    {
      id: "invalidApplicants",
      label: "Invalid Applicants",
      data: uploadResponse?.failed,
      count: uploadResponse?.failed_count || 0,
    },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0]?.id);
  const [uploadedExcelFile, setUploadedExcelFile] = useState<any>(null);

  const [allItemList, setAllItemList] = useState<any[]>(
    tabs.find((d) => d.id === activeTab)?.data || [],
  );

  const [errors, setErrors] = useState<ErrorType | null>(null);

  // API
  const { callApi, loading: loadingUpload } = useApi<any>("", {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  // table column
  const columns: ColumnsType<any> = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      onCell: () => cellWidth(100),
      render: (text: string, record: any, index: number) => index + 1,
      sorter: false,
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      onCell: () => cellWidth(160),
      render: (text: any) => text || "-",
      sorter: (a, b) => safeStringSort(a.firstName, b.firstName),
    },
    {
      title: "Middle Name",
      dataIndex: "middleName",
      onCell: () => cellWidth(160),
      render: (text: any) => text || "-",
      sorter: (a, b) => safeStringSort(a.middleName, b.middleName),
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      onCell: () => cellWidth(160),
      render: (text: any) => text || "-",
      sorter: (a, b) => safeStringSort(a.lastName, b.lastName),
    },
    {
      title: "Applicant Mobile Number",
      dataIndex: "phone",
      onCell: () => cellWidth(160),
      render: (text: any) => text || "-",
      sorter: (a: any, b: any) => safeNumberSort(a.phone, b.phone),
    },
    {
      title: "Applicant Email Id",
      dataIndex: "email",
      onCell: () => cellWidth(160),
      render: (text: any) => text || "-",
      sorter: (a, b) => safeStringSort(a.email, b.email),
    },
    {
      title: "Applicant Registration Number/CRN",
      dataIndex: "applicantRegistrationNumberCrn",
      onCell: () => cellWidth(240),
      render: (text: any) => text || "-",
      sorter: (a, b) =>
        safeStringSort(
          a.applicantRegistrationNumberCrn,
          b.applicantRegistrationNumberCrn,
        ),
    },
    {
      title: "Applicant Employee Id/Code",
      dataIndex: "employeeId",
      onCell: () => cellWidth(200),
      render: (text: any) => text || "-",
      sorter: (a, b) => safeStringSort(a.employeeId, b.employeeId),
    },
    {
      title: "Joining Date",
      dataIndex: "joiningDate",
      onCell: () => cellWidth(160),
      render: (text: any) => {
        const date = text ? formatDateDDMMMMYYYY(text) : "-";
        return <div>{date}</div>;
      },
      sorter: (a: any, b: any) => safeDateSort(a.joiningDate, b.joiningDate),
    },
  ];

  const handleDownloadTemplate = () => {
    const link = document.createElement("a");

    link.href = "/assets/files/bulk_invite_sample_5_candidates.xlsx";
    link.download = "bulk-sample-template.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;
    setUploadedExcelFile(file);
    document
      .getElementById("excel-data")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });

    handleClearError(setErrors, "file");
  };
  const escapeHtml = (value: any) =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  // const showFailedRowsPopup = (data: any) => {
  //   const failed: any[] = Array.isArray(data?.failed) ? data.failed : [];
  //   if (failed.length === 0) return;

  //   const successCount = data?.success_count || 0;
  //   const failedCount = data?.failed_count || failed.length;

  //   const rowsHtml = failed
  //     .map((row) => {
  //       const name = [row?.firstName, row?.middleName, row?.lastName]
  //         .filter(Boolean)
  //         .join(" ");

  //       return `
  //       <div style="padding:10px 12px;margin-bottom:8px;border:1px solid #f5c2c7;
  //                   border-left:4px solid #dc3545;border-radius:8px;background:#fff5f5;">
  //         <div style="font-weight:600;color:#1b2a3a;">
  //           Row ${escapeHtml(row?.row_number ?? "-")}${name ? ` · ${escapeHtml(name)}` : ""}
  //         </div>
  //         ${
  //           row?.field
  //             ? `<div style="font-size:12px;color:#64748b;margin-top:2px;">
  //                  Field: <b>${escapeHtml(row.field)}</b>
  //                </div>`
  //             : ""
  //         }
  //         <div style="font-size:13px;color:#b02a37;margin-top:4px;">
  //           ${escapeHtml(row?.reason || "Invalid data")}
  //         </div>
  //       </div>`;
  //     })
  //     .join("");

  //   Swal.fire({
  //     icon: "warning",
  //     title: `${failedCount} candidate${failedCount > 1 ? "s" : ""} failed`,
  //     html: `
  //     <div style="font-size:14px;margin-bottom:12px;color:#475569;">
  //       ${successCount} assigned successfully, ${failedCount} failed.
  //       Please correct the rows below and upload again.
  //     </div>
  //     <div style="max-height:320px;overflow-y:auto;text-align:left;">
  //       ${rowsHtml}
  //     </div>`,
  //     confirmButtonText: "OK",
  //     width: 600,
  //   });
  // };

  const showFailedRowsPopup = (data: any) => {
    // Support both success and error API response formats
    const failed: any[] = Array.isArray(data?.details?.failed_rows)
      ? data.details.failed_rows
      : Array.isArray(data?.failed)
        ? data.failed
        : [];

    const successCount = data?.success_count || 0;
    const failedCount = data?.details?.failed_rows?.length
      ? data.details.failed_rows.length
      : data?.failed_count || failed.length;

    const errorMessage =
      data?.error || "Some candidates could not be uploaded.";

    // If there are no failed rows, show the general API error
    if (failed.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: errorMessage,
        confirmButtonText: "OK",
        confirmButtonColor: "#fe7f08",
      });
      return;
    }

    const rowsHtml = failed
      .map((row: any) => {
        const name = [row?.firstName, row?.middleName, row?.lastName]
          .filter(Boolean)
          .join(" ");

        return `
        <div style="
          padding: 12px;
          margin-bottom: 10px;
          border: 1px solid #f5c2c7;
          border-left: 4px solid #dc3545;
          border-radius: 8px;
          background: #fff5f5;
          text-align: left;
        ">
          <div style="font-weight: 600; color: #1b2a3a;">
            Excel Row ${escapeHtml(row?.row_number ?? "-")}
            ${name ? ` · ${escapeHtml(name)}` : ""}
          </div>

          ${
            row?.email
              ? `<div style="font-size: 12px; color: #64748b; margin-top: 4px;">
                   Email: ${escapeHtml(row.email)}
                 </div>`
              : ""
          }

          ${
            row?.phone
              ? `<div style="font-size: 12px; color: #64748b; margin-top: 2px;">
                   Mobile: ${escapeHtml(row.phone)}
                 </div>`
              : ""
          }

          ${
            row?.field
              ? `<div style="font-size: 12px; color: #64748b; margin-top: 4px;">
                   Field: <b>${escapeHtml(row.field)}</b>
                 </div>`
              : ""
          }

          <div style="
            font-size: 13px;
            color: #b02a37;
            margin-top: 6px;
            white-space: normal;
            overflow-wrap: anywhere;
          ">
            <b>Reason:</b> ${escapeHtml(
              row?.reason || row?.message || "Invalid data",
            )}
          </div>
        </div>
      `;
      })
      .join("");

    Swal.fire({
      icon: data?.success === false ? "error" : "warning",
      title: data?.error
        ? "Excel Validation Failed"
        : `${failedCount} candidate${failedCount !== 1 ? "s" : ""} failed`,
      html: `
      <div style="
        font-size: 14px;
        margin-bottom: 14px;
        color: #475569;
        text-align: left;
      ">
        <div style="font-weight: 600; margin-bottom: 6px;">
          ${escapeHtml(errorMessage)}
        </div>

        ${
          data?.details?.total_rows !== undefined
            ? `<div>Total rows: ${escapeHtml(data.details.total_rows)}</div>`
            : ""
        }

        ${
          data?.success === false
            ? `<div>Failed rows: ${escapeHtml(failedCount)}</div>`
            : `<div>${escapeHtml(successCount)} assigned successfully, ${escapeHtml(failedCount)} failed.</div>`
        }

        <div style="margin-top: 8px;">
          Please correct the following rows and upload again.
        </div>
      </div>

      <div style="max-height: 350px; overflow-y: auto; padding-right: 4px;">
        ${rowsHtml}
      </div>
    `,
      confirmButtonText: "OK",
      confirmButtonColor: "#fe7f08",
      width: 650,
    });
  };

  const handleUploadBulkData = async () => {
    try {
      setUploadResponse(null);

      const payload = {
        file: uploadedExcelFile,
        package_id: orderFilter?.package_id ?? "",
        project_id: orderFilter?.project_id ?? "",
        program_id: orderFilter?.program_id ?? "",
        department_id: orderFilter?.department_id ?? "",
      };

      const formData = new FormData();

      Object.entries(payload).forEach(([key, value]) => {
        if (value === null || value === undefined) return;
        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value);
        } else {
          formData.append(key, String(value));
        }
      });

      const res = await callApi(
        formData,
        `${webservice_url.assignOrderToBulk}/${orderId}`,
      );

      if (res?.success) {
        const data = res?.data || null;
        const validRows = Array.isArray(data?.success) ? data.success : [];
        const failedRows = Array.isArray(data?.failed) ? data.failed : [];

        setUploadResponse(data);
        if (validRows.length === 0 && failedRows.length > 0) {
          setActiveTab("invalidApplicants");
          setAllItemList(failedRows);
        } else {
          setActiveTab("allApplicants");
          setAllItemList(validRows);
        }
        if ((data?.success_count || 0) > 0) {
          toast.success(res?.message || "Uploaded successfully!");
        }
        showFailedRowsPopup(data);
      }
    } catch (error: any) {
      console.error("Submission failed:", error);

      const responseData = error?.response?.data;

      if (
        Array.isArray(responseData?.details?.failed_rows) &&
        responseData.details.failed_rows.length > 0
      ) {
        // Show every validation error returned by the backend
        showFailedRowsPopup(responseData);
      } else {
        // Handle other errors, such as network errors or server errors
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text:
            responseData?.error ||
            error?.message ||
            "Invite failed. Please try again.",
          confirmButtonText: "OK",
          confirmButtonColor: "#fe7f08",
        });
      }
    }
  };

  return (
    <div className="px-2 px-md-3 ">
      <div className="fw-semibold text-dark mb-3 pt-sm-2">Step 1</div>

      {/* <div className="card shadow-sm border-0 bg-soft-danger">
        <div className="card-body">
          <div className="row g-3">
            <div className=" col-sm-6 col-lg-4">
              <div className="d-flex">
                <span className="text-muted fw-semibold me-2">
                  Organization:
                </span>
                <span>{orderFilter?.organization ?? "-"}</span>
              </div>
            </div>

            <div className=" col-sm-6 col-lg-4">
              <div className="d-flex">
                <span className="text-muted fw-semibold me-2">Account:</span>
                <span>{orderFilter?.project ?? "-"}</span>
              </div>
            </div>

            <div className=" col-sm-6 col-lg-4">
              <div className="d-flex">
                <span className="text-muted fw-semibold me-2">Location:</span>
                <span>{orderFilter?.location ?? "-"}</span>
              </div>
            </div>

            <div className=" col-sm-6 col-lg-4">
              <div className="d-flex">
                <span className="text-muted fw-semibold me-2">Program:</span>
                <span>{orderFilter?.program ?? "-"}</span>
              </div>
            </div>

            <div className=" col-sm-6 col-lg-4">
              <div className="d-flex">
                <span className="text-muted fw-semibold me-2">Department:</span>
                <span>{orderFilter?.department ?? "-"}</span>
              </div>
            </div>

            <div className=" col-sm-6 col-lg-4">
              <div className="d-flex">
                <span className="text-muted fw-semibold me-2">Package:</span>
                <span>{orderFilter?.package ?? "-"}</span>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="card border-0 shadow-sm rounded-4 overflow-hidden order-config-card">
        <div className="order-config-header d-flex align-items-center justify-content-between flex-wrap gap-2 px-4 py-3">
          <div className="d-flex align-items-center gap-3">
            <div className="order-config-icon">
              <i className="ti ti-clipboard-check"></i>
            </div>
            <div>
              <h5 className="mb-1 fw-bold text-dark">Order Configuration</h5>
              <p className="mb-0 text-muted small">
                Review the account and package details for this order.
              </p>
            </div>
          </div>
          <span className="order-config-badge">
            <i className="ti ti-circle-check me-1"></i>
            Configuration Loaded
          </span>
        </div>

        <div className="card-body p-3 p-md-4">
          <div className="row g-3">
            <div className="col-12 col-md-6 col-xl-4">
              <div className="order-config-item h-100">
                <div className="order-config-item-icon">
                  <i className="ti ti-building-community"></i>
                </div>
                <div className="min-w-0">
                  <div className="order-config-label">Organization</div>
                  <div className="order-config-value">
                    {orderFilter?.organization || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
              <div className="order-config-item h-100">
                <div className="order-config-item-icon">
                  <i className="ti ti-briefcase-2"></i>
                </div>
                <div className="min-w-0">
                  <div className="order-config-label">Account</div>
                  <div className="order-config-value">
                    {orderFilter?.project || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
              <div className="order-config-item h-100">
                <div className="order-config-item-icon">
                  <i className="ti ti-map-pin"></i>
                </div>
                <div className="min-w-0">
                  <div className="order-config-label">Location</div>
                  <div className="order-config-value">
                    {orderFilter?.location || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
              <div className="order-config-item h-100">
                <div className="order-config-item-icon">
                  <i className="ti ti-folders"></i>
                </div>
                <div className="min-w-0">
                  <div className="order-config-label">Program</div>
                  <div className="order-config-value">
                    {orderFilter?.program || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
              <div className="order-config-item h-100">
                <div className="order-config-item-icon">
                  <i className="ti ti-building"></i>
                </div>
                <div className="min-w-0">
                  <div className="order-config-label">Department</div>
                  <div className="order-config-value">
                    {orderFilter?.department || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-4">
              <div className="order-config-item h-100">
                <div className="order-config-item-icon">
                  <i className="ti ti-package"></i>
                </div>
                <div className="min-w-0">
                  <div className="order-config-label">Package</div>
                  <div className="order-config-value">
                    {orderFilter?.package || "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 pt-2">
        {orderFilter?.package_description && (
          <>
            <div className=" mb-2 fw-semibold">Package Scope</div>
            <div className=" p-2 text-dark fw-semibold border rounded-3">
              {orderFilter?.package_description}
            </div>
          </>
        )}

        <div className="mt-4 fw-semibold text-dark">Step 2</div>
        <div className="mb-1">
          Download template For Upload Excel
          <i
            className="ti ti-download text-primary fs-18 ms-1"
            style={{ cursor: "pointer" }}
            onClick={handleDownloadTemplate}
          ></i>
          .
        </div>
        <div className="mt-3 fw-semibold text-dark">Step 3</div>

        <div className="mb-3">
          <label htmlFor="file" className="form-label fw-semibold">
            Upload Excel File
          </label>

          <div className="d-flex align-items-center gap-2">
            <input
              type="file"
              name="file"
              className="form-control grow-1"
              accept=".xls,.xlsx,.pdf"
              style={{ maxWidth: 400 }}
              onChange={handleFileChange}
              disabled={loadingUpload}
            />
            <div>
              <button
                type="button"
                className="btn btn-primary py-2"
                style={{ width: "max-content" }}
                onClick={handleUploadBulkData}
                disabled={loadingUpload}
              >
                {loadingUpload ? "Uploading..." : "Upload Excel"}
              </button>
            </div>
          </div>
          <ErrorMessage message={errors?.file} />
        </div>

        <div className="mt-2">
          <span className="fw-bold pe-2 d-inline-block">Note:-</span>
          You can Upload 50 candidates at one time.
        </div>

        {!uploadResponse && (
          <>
            {!loadingUpload ? (
              <div className="py-5 my-3"></div>
            ) : (
              <div>
                <Loading />
              </div>
            )}
          </>
        )}
        {!!uploadResponse && (
          <div id="excel-data">
            <div className="mt-3 fw-semibold text-dark mb-3">
              Step 4: Excel data will be populated below in case of duplicate
              and incorrect data candidate will be labelled as Invalid.
            </div>

            <TabItems
              tabList={tabs}
              activeTab={activeTab}
              tabCountClass="d-flex align-items-center gap-1"
              handleClick={(d) => {
                setActiveTab(d.id);
                setAllItemList(d.data);
              }}
            />

            <div className="mt-3">
              <Table
                dataSource={allItemList}
                columns={columns}
                Selection={false}
                hideSizeChanger={true}
              />
            </div>
          </div>
        )}
      </div>
      {/* )} */}
    </div>
  );
};

export default BulkAssign;
